import { useMutation } from "react-query";
import { updateNotes } from "components/notes/lib/data";

export const useUpdateNotes = () => {
    return useMutation((items) => updateNotes(items));
};
